import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  className?: string;
}

export default function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className={`text-sm ${className}`}>
      <ol className="flex items-center flex-wrap gap-1.5 text-foreground-500">
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
            {idx < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-foreground-300 w-4 h-4 flex items-center justify-center"></i>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}